













import { Component, Vue, Prop} from 'vue-property-decorator';
import { Player } from '@/game/player';

@Component({
  name: 'ranking'
})
export default class Ranking extends Vue {
    
    @Prop() players!: Player[];

    get ranking() {
        const scores = this.players.map(p => ({ id: p.id, name: p.name, points: p.points }));
        scores.sort((a,b) => b.points - a.points);
        return scores;
    }
}
